const TOOLS = [
  { id: 'none',   label: '✋ None',   hint: 'Scrub mode' },
  { id: 'line',   label: '／ Line',   hint: 'Straight line' },
  { id: 'circle', label: '○ Circle',  hint: 'Head or ball tracker' },
  { id: 'angle',  label: '∠ Angle',   hint: 'Line + degree readout' }
];

const COLORS = [
  '#f4a948',  // amber — default
  '#d14324',  // flag red
  '#9fd68a',  // fairway light
  '#e7d89c',  // cream
  '#7fb3d5',  // sky — for shaft plane
  '#ffffff'
];

export default function DrawToolbar({ activeTool, onToolChange, activeColor, onColorChange }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[10px] uppercase tracking-[0.2em] text-ink-400 mr-1">Draw</span>
      {TOOLS.map(t => (
        <button
          key={t.id}
          onClick={() => onToolChange(t.id)}
          title={t.hint}
          className={`px-2.5 py-1.5 rounded text-[11px] font-mono transition ${
            activeTool === t.id
              ? 'bg-cream-100 text-fairway-950'
              : 'bg-fairway-800 text-ink-200 hover:bg-fairway-700'
          }`}
        >
          {t.label}
        </button>
      ))}
      <div className="flex items-center gap-1 ml-2">
        {COLORS.map(c => (
          <button
            key={c}
            onClick={() => onColorChange(c)}
            className={`w-5 h-5 rounded-full transition ${
              activeColor === c ? 'ring-2 ring-offset-2 ring-offset-fairway-900 ring-cream-100' : ''
            }`}
            style={{ background: c }}
            title={c}
          />
        ))}
      </div>
    </div>
  );
}
